import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["id"];
import { computed } from "vue";
import trans from "../../services/Translator";
export default /*@__PURE__*/ _defineComponent({
    __name: 'FieldControlInfo',
    props: {
        form: {},
        validation: {},
        field: {},
        fieldId: {},
        data: {}
    },
    setup(__props) {
        const props = __props;
        const value = computed(() => {
            const data = props.data;
            if (!data) {
                return undefined;
            }
            // shortcut if data cannot be translation key
            if (typeof data !== 'string' || data.indexOf(' ') !== -1) {
                return data;
            }
            const key1 = `${props.form.name}.${props.field.name}.${data}`;
            const key2 = `${props.field.name}.${data}`;
            return trans(key1, {}, () => trans(key2, {}, data));
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("span", {
                id: __props.fieldId,
                class: "form__control"
            }, _toDisplayString(value.value), 9, _hoisted_1));
        };
    }
});
